import axios from 'axios';
import Events from '../utils/Event';
import { endPoint, dataExist } from '../utils/Utils';

const c = (() => {
  const vault = [];

  const fetch = () => { // getAllItems
    axios
      .get(endPoint.course)
      .then((response) => {
        Events.emit('courses', response.data);
      });
  };

  const get = () =>
    // get all courses available
    vault;
  const add = (id) => {
    vault.push(id);
  };

  const arrangeBundles = (item) => { // sortBundleCourses
    if (dataExist(item, 'bundle')) {
      const IDs = [];
      item.bundle.forEach((course) => {
        if (get().indexOf(course.id) < 0) {
          IDs.push(course.id);
        }
      });
      add({ id: item.id, bundle: IDs });
    }
  };

  const handleBundles = () => { // getAllBundlesAndCourses
    fetch();

    Events.on('courses', (data) => {
      data.forEach(item => arrangeBundles(item));
    });
  };

  return {
    get,
    add,
    handleBundles,
  };
})();

export default c;



// WEBPACK FOOTER //
// ./components/course-helper.js